module.exports = __webpack_public_path__ + "img/hair_front_female_middle_part.2376f813.png";